/**
 * src/web/components/chat-room-delete-panel.jsx
 */

import React from 'react'
import connect from '../../connects/chat-room-delete-panel'
import {
  Card,
  CardTitle,
  CardText,
  CardActions
} from 'react-toolbox/lib/card'
import {
  Button,
  IconButton,
} from 'react-toolbox/lib/button'
import {
  List,
  ListItem,
} from 'react-toolbox/lib/list'
import {
  IconMenu,
  MenuItem,
  MenuDivider,
} from 'react-toolbox/lib/menu'
import Checkbox from 'react-toolbox/lib/checkbox'
import theme from './themes/flat-card.css'
import successButtonTheme from './themes/success-button.css'
import ConfirmDialog from './confirm-dialog.jsx'

const devicePC = true

class ChatRoomDeletePanel extends React.Component {
  state = {　complete: false, deleteConfirm: false, deleteCheck: false  }

  toggleConfirmDialog = () => this.setState({ deleteConfirm: !this.state.deleteConfirm })
  onCancel = () => {
    this.setState({ deleteConfirm: !this.state.deleteConfirm, deleteCheck: !this.state.deleteCheck })
  }
  deleteChatRoom = (props) => {
    this.toggleConfirmDialog()
    this.props.deleteChatRoom(props, devicePC)
  }

  onCheck = () => {
    this.setState({ deleteCheck: !this.state.deleteCheck })
  }

  render() {
    const {
      t,
      chatRoomName,
      deleteChatRoom,
      messagePage,
      closeRightSidePage,
    } = this.props

    return (
        <Card theme={theme}>
          <CardText>
              <p style={{ fontSize: 16, color: 'black', marginBottom: 5　}}>
                {t('label:チャットルームを削除します')}
              </p>
              <p style={{ fontSize: 16, color: 'black', marginBottom: 5　}}>
                {t('label:チャットルームを削除していいですか')}
              </p>
              <Checkbox 
                theme={theme}
                className='deleteCheck'
                checked={this.state.deleteCheck} 
                onChange={this.onCheck} 
                label={t('label:この操作はチャットルームに参加している全てのユーザーに影響します')} />
          </CardText>
          <CardActions>
            <Button raised primary
              type="submit"
              style={{ width: '100%' }}
              label={t('label:削除')}
              disabled={!this.state.deleteCheck}
              onClick={this.toggleConfirmDialog}
            />
          </CardActions>
          <ConfirmDialog key="dialog"
            open={this.state.deleteConfirm}
            title={t('label:チャットルームを削除していいですか')}
            description={t('label:この操作は取り消せません')}
            yesLabel={t('label:削除')}
            noLabel={t('label:取り消し')}
            onNo={this.onCancel}
            onYes={() => this.deleteChatRoom(this.props)}/>
        </Card>
    )
  }
}

export default connect(ChatRoomDeletePanel)



// WEBPACK FOOTER //
// ./src/web/components/chat-room-delete-panel.jsx